import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WalPageService } from '../../../services/session/wal-page.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { HeaderSectionDirective } from '../../../directives/header-section.directive';
import { FooterSectionDirective } from '../../../directives/footer-section.directive';
import { ISessionDetails } from '../../../interfaces/session-details';
import { PageElementSpec } from '../../../classes/page-element-spec';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-xtr-view-items',
    standalone: true,
    imports: [FormsModule, CommonModule],
    templateUrl: './xtr-view-items.component.html',
    styleUrl: './xtr-view-items.component.css'
})
export class XtrViewItemsComponent implements OnInit {

    private readonly router = inject(Router);
    private readonly dataExchangeService = inject(DataExchangeService);
    private readonly walPageService = inject(WalPageService);
    private readonly logger = inject(NGXLogger);

    extraViewItems: PageElementSpec<string>[] = [];
// [
//     new PageElementSpec({elementType: "text", key: "elem1", label: "Welcome to the app!", value: "" }),
//     new PageElementSpec({ elementType: "link", key: "elem2",  label: "Go to Google", value: "" }),
//     new PageElementSpec({ elementType: "input", key: "elem3",  label: "", value: "" }),
//     new PageElementSpec({ elementType: "image", key: "elem4",  label: "", value: "" }),
//     new PageElementSpec({ elementType: "button", key: "elem5",  label: "Submit", value: "" })
// ];

//     extraViewItems: any[] =

// [
//   { "elementType": "text", "key": "elem1", "label": "Welcome to the app!", value: "" },
//   { "elementType": "link", "key": "elem2",  "label": "Go to Google", "href": "https://google.com", value: "" },
//   { "elementType": "input", "key": "elem3",  "placeholder": "Enter your name", value: "" },
//   { "elementType": "image", "key": "elem4",  "src": "https://via.placeholder.com/300x150", "alt": "Placeholder", value: "" },
//   { "elementType": "button", "key": "elem5",  "label": "Submit", value: "" }
// ];


  ngOnInit() {
    // Get the parameters from the caller (Walletron)
    let region = this.dataExchangeService.getRegion();
    let session: ISessionDetails = this.dataExchangeService.getSession();

    if (region && session) {
      // Retrieve notification history
      this.geExtraViewItems(region, session.walPageUuid, session.brandCode || '');
    }
  }

  geExtraViewItems(region: string, sessionId: string, brandCode: string) {
    this.walPageService.geExtraViewItems(region, sessionId, brandCode, 'serialNumber')
    .subscribe({
      next: (response) => {
        if (response) {
          console.log('geExtraViewItems', response);
          this.extraViewItems = response;
          }
      },
      error: (error) => {
        console.log('error', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }


}
